/**
 * 研助お知らせのカテゴリ。バックエンド `backend/src/constants/announcementCategories.ts` と同じ並び・キー。
 * 表示名は i18n `announcements.category_<key>`。
 */
export const ANNOUNCEMENT_CATEGORIES = [
  'general',
  'fx_ea',
  'arena',
  'keiba',
  'econ',
  'banquet',
  'tools',
] as const;

export type AnnouncementCategory = (typeof ANNOUNCEMENT_CATEGORIES)[number];

export const ANNOUNCEMENT_CATEGORY_DEFAULT_LABELS: Record<AnnouncementCategory, string> = {
  general: '研助全般',
  fx_ea: 'FXドル円編 EA',
  arena: 'AIトレードアリーナ',
  keiba: 'AI競馬アリーナ',
  econ: 'AI投資情報',
  banquet: '熱狂の宴',
  tools: '計助・ラボ助・サンプル管理などのツール',
};

export function isAnnouncementCategory(value: unknown): value is AnnouncementCategory {
  return typeof value === 'string' && (ANNOUNCEMENT_CATEGORIES as readonly string[]).includes(value);
}
